// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"52":"cc47d91f","972":"a97b4376"}[chunkId] + ".js";
};